export default __webpack_public_path__ + "static/realWorldImg1-99f9116409a2034dd283cdd10f597120.webp";